// Time-off request types
export const TIME_OFF_TYPES = {
  VACATION: 'VACATION',
  SICK_DAY: 'SICK_DAY',
  PERSONAL: 'PERSONAL',
} as const;

// Request statuses
export const REQUEST_STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
} as const;


// Calendar configuration
export const CALENDAR_CONFIG = {
  DAYS_PER_WEEK: 7,
  MAX_VISIBLE_REQUESTS: 3,
  MONTH_NAMES: [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ],
  DAY_NAMES: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
} as const;

// Color scheme for request types
export const REQUEST_TYPE_COLORS = {
  VACATION: '#1976d2', // Blue (primary)
  SICK_DAY: '#d32f2f', // Red (error)
  PERSONAL: '#4ecdc4', // Teal
} as const;

// Request type labels
export const REQUEST_TYPE_LABELS = {
  VACATION: 'Vacation',
  SICK_DAY: 'Sick Leave',
  PERSONAL: 'Personal',
} as const;

// Status color mapping
export const STATUS_COLORS = {
  PENDING: 'warning',
  APPROVED: 'success',
  DENIED: 'error',
} as const;

// Type color mapping
export const TYPE_COLORS = {
  VACATION: 'primary',
  SICK_DAY: 'error',
  PERSONAL: 'secondary',
} as const;

// Tab indices (adjusted for conditional rendering)
export const TAB_INDICES = {
  CALENDAR: 0,
  LEAVE_BALANCE: 1,
  REQUESTS: 2, // Only visible for admins
  REQUEST_HISTORY: 2, // Index 2 for non-admins, index 3 for admins
  LEAVE_BALANCES: 3, // Only visible for admins
  HOLIDAYS: 4, // Only visible for admins
} as const;

// Function to get the correct tab index based on user role
export const getTabIndex = (tabName: keyof typeof TAB_INDICES, isAdmin: boolean): number => {
  switch (tabName) {
    case 'CALENDAR':
      return 0;
    case 'LEAVE_BALANCE':
      return 1;
    case 'REQUESTS':
      return isAdmin ? 2 : -1; // Not visible for non-admins
    case 'REQUEST_HISTORY':
      return isAdmin ? 3 : 2; // Index 2 for non-admins, index 3 for admins
    case 'LEAVE_BALANCES':
      return isAdmin ? 4 : -1; // Not visible for non-admins
    case 'HOLIDAYS':
      return isAdmin ? 5 : -1; // Not visible for non-admins
    default:
      return -1;
  }
};

// Form validation messages
export const TIME_OFF_VALIDATION_MESSAGES = {
  START_DATE_REQUIRED: 'Start date is required',
  END_DATE_REQUIRED: 'End date is required',
  END_DATE_AFTER_START: 'End date must be after start date',
} as const;

// API error messages
export const TIME_OFF_ERROR_MESSAGES = {
  CREATE_REQUEST: 'Failed to create time-off request',
  APPROVE_REQUEST: 'Failed to approve request',
  DENY_REQUEST: 'Failed to deny request',
} as const;

// Tooltip messages
export const TOOLTIP_MESSAGES = {
  ADDITIONAL_REQUESTS: 'Additional requests:',
} as const;
